/**
 * An enum containing API endpoints for the Eiko service.
 * @readonly
 * @enum {string}
 */
export enum EEikoApi {
  PROFILE = '/eiko-profile',
  OFFER = '/eiko-offer',
  ORDER = '/eiko-order'
}
